<template>
  <div class="zhuli">

    <transition name="el-fade-in-linear">
      <div v-if="type"
        style="box-shadow: 0 0 .1042rem rgba(0, 0, 0, .25);width:6rem;height: 3rem;position:absolute;z-index: 99 !important;background-color: white;top: -.2rem;left: -2rem;">
        <!-- <img :src="this.imgurl" alt=""> -->
        <el-image :src="'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + this.imgurl" alt="QR Code"
          style="width: 1rem;height: 1rem;margin-left:2.45rem;margin-top: 0.5rem;">
          <div slot="placeholder">
            <!-- <el-spin indicator="el-icon-loading" size="40px"></el-spin> -->
            <div style="text-align: center;color: rgb(1, 162, 153);font-size: .1rem;margin-top: .5rem;">加载中...</div>
          </div>
        </el-image>
        <el-button type="success" style="margin-left: 2.7rem;margin-top: 0.3rem;" @click="chaxun">我已支付</el-button>
      </div>
    </transition>
    <img src="../../assets/close.png" @click="type = ''" v-if="type"
      style=" width: .0521rem;height: .0521rem;position:absolute;  z-index: 1000;left: 3.85rem;top: -.1rem;" alt="">
    <img src="../../assets/Tzhulibglingdang.png" alt="">
    <div class="title">需求提醒小助手
    </div>
    <div class="line"></div>
    <div class="txt">购买此服务可以在家长发布需求的第一时间就收到短信提醒 第一时间进行抢单</div>
    <div class="flex" style="width: 3.7813rem;" v-if="buy">
      <div
        style=" display: flex; width: 1.2188rem;justify-content: space-between; margin-top: .5781rem;margin-left: .25rem;">
        <div class="box">
          <div class="son"
            style="width: .4896rem;height: .4896rem;/* 19.9 */color: rgb(20, 10, 9);font-family: 苹方;font-size: .125rem;font-weight: 400;line-height: .1146rem;letter-spacing: -0.0001rem;text-align: center;padding-top: .1406rem;">
            19.9<span
              style="/* 元/季度 */color: rgb(132, 81, 16);font-family: 苹方;font-size: .0833rem;font-weight: 400;line-height: .1146rem;letter-spacing: -0.0001rem;text-align: center;margin-top: .0104rem;">元/季度</span>
          </div>
          <button style="margin-left: 0;margin-top: .0677rem;" @click="mai(1)">服务续费</button>
        </div>
        <div class="box">
          <div class="son"
            style="width: .4896rem;height: .4896rem;/* 19.9 */color: rgb(20, 10, 9);font-family: 苹方;font-size: .125rem;font-weight: 400;line-height: .1146rem;letter-spacing: -0.0001rem;text-align: center;padding-top: .1406rem;">
            49.9<span
              style="/* 元/季度 */color: rgb(132, 81, 16);font-family: 苹方;font-size: .0833rem;font-weight: 400;line-height: .1146rem;letter-spacing: -0.0001rem;text-align: center;margin-top: .0104rem;">元/年</span>
          </div>
          <button style="margin-left: 0;margin-top: .0677rem;" @click="mai(2)">服务续费</button>
        </div>
      </div>
      <div>
        <div class="succes">服务已生效</div>
        <div class="time">{{ buytime }}到期 </div>
        <div></div>
      </div>

    </div>
    <div class="flex" v-else style="  margin-left: .9063rem;
  width: 2.6042rem;
  margin-top: .1927rem;">
      <div class="box">
        <div class="son">19.9<span>元/季度</span></div>
        <button @click="mai(1)">服务购买</button>
      </div>
      <div class="box">
        <div class="son">49.9 <span>元/年</span></div>
        <button @click="mai(2)">服务购买</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      buy: false,
      type: '',
      orderId: '',
      imgurl: '',
      buytime: ''
    }
  },
  methods: {
    mai(a) {
      // console.log(a);
      this.$http.get('/Api/Pay/snow', {
        headers: {
          'Authorization': localStorage.getItem('Authorization')
        }
      }).then(res => {
        console.log(res.data.data);
        console.log(res);
        this.orderId = res.data.data
        this.type = a
        this.$http.post('/Api/Pay/web', {}, {
          params: {
            orderId: res.data.data,
            type: a
          },
          headers: {
            'Authorization': localStorage.getItem('Authorization')
          }
        }).then(postres => {
          // console.log(postres);
          this.imgurl = postres.data.code_url
          // console.log(this.imgurl);
        })
      })
    }, chaxun() {
      this.$http.post('/Api/Pay/check', {}, {
        params: {
          orderId: this.orderId,
          plate: 1
        },
        headers: {
          'Authorization': localStorage.getItem('Authorization')
        }
      }).then(res => {
        console.log(res);

        if (res.data.data == true) {
          this.$message({
            type: 'success',
            message: '支付成功'
          });
          this.type = ''
          this.$router.go(0);

        }
        else {
          this.$message({
            type: 'error',
            message: '支付失败'
          });
          this.type = ''
        }

      })
    }
  },
  created() {
    this.$http.get('/Api/Teacher', {
      headers: {
        'Authorization': localStorage.getItem('Authorization')
      }
    }).then(res => {
      console.log(res.data.data.demandNotify);
      if (!res.data.data.demandNotify) {
        this.buy = false
      }
      else {
        this.buy = true
        const date = new Date(res.data.data.demandNotify);
        this.buytime = `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
      }
    })
  }


}
</script>

<style scoped>
.zhuli {
  width: 851px;
  height: 446px;
  background: url('../../assets/Tzhulibg.png') center;
  background-size: 100% 100%;
  margin-top: 30px;
  position: relative;
  padding-top: 42px;
}

.zhuli img {
  display: block;
  position: absolute;
  width: 108px;
  height: 108px;
  top: 44px;
  left: 48px;
}

.zhuli .title {
  /* 需求提醒小助手 */
  display: inline-block;
  width: 172px;
  height: 47px;
  background: linear-gradient(135.00deg, rgb(233, 178, 102), rgb(255, 234, 205), rgb(235, 177, 98), rgb(208, 158, 91));
  -webkit-background-clip:
    text;
  -webkit-text-fill-color:
    transparent;
  background-clip:
    text;
  -webkit-text-fill-color: transparent;
  font-family: 苹方;
  font-size: 24px;
  font-weight: 600;
  line-height: 38px;
  letter-spacing: 0px;
  text-align: left;
  margin-left: 186px;
}

.line {
  /* 一级标签页/Padding (style) */
  width: 468px;
  height: 2px;
  background: rgb(251, 225, 189);
  margin-left: 186px;
}

.txt {
  /*  */
  width: 468px;
  height: 76px;
  color: rgb(251, 225, 189, 0.7);
  font-family: 苹方;
  font-size: 18px;
  font-weight: 400;
  line-height: 34px;
  letter-spacing: 0px;
  text-align: left;
  margin-left: 186px;
}

.son {
  /* button/default/default/none/on/off (style) */
  width: 150px;
  height: 150px;
  box-sizing: border-box;
  background: linear-gradient(135.00deg, rgb(233, 178, 102) 6.493%, rgb(255, 234, 205) 51.949%, rgb(235, 177, 98) 82.872%, rgb(208, 158, 91) 93.498%);
  border: 4px solid rgb(181, 143, 76);
  border-radius:
    20px;
  /* 19.9 */

  color: rgb(20, 10, 9);
  font-family: 苹方;
  font-size: 36px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.009999999776482582px;
  text-align: center;
  padding-top: 48px;
}

.son span {
  /* 元/季度 */
  display: block;
  color: rgb(132, 81, 16);
  font-family: 苹方;
  font-size: 20px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.009999999776482582px;
  text-align: center;
  margin-top: 11px;
}

.flex {
  display: flex;
  justify-content: space-between;

}

.box button {
  /* button/default/default/none/on/off (style) */
  width: 91px;
  height: 33px;
  background: rgb(229, 189, 135);
  border-radius:
    4px;
  margin-top: 23px;
  margin-left: 30px;
  /* 服务购买 */
  color: rgb(0, 0, 0, 0.8);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.009999999776482582px;
  text-align: center;
}

.succes {
  /* 矩形 39 */
  width: 238px;
  height: 71px;
  background: linear-gradient(135.00deg, rgb(233, 178, 102) 6.36%, rgb(255, 234, 205) 51.522%, rgb(235, 177, 98) 82.245%, rgb(208, 158, 91) 92.803%);
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius:
    47px;
  margin-top: 138px;
  /* 服务已生效 */
  font-family: 苹方;
  font-size: 36px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: center;
  color: rgb(0, 0, 0);
  padding-top: 24px;
}

.time {
  /* 2023年9月21日到期 */
  width: 149px;
  height: 38px;
  color: rgb(251, 225, 189, 0.7);
  font-family: 苹方;
  font-size: 16px;
  font-weight: 400;
  line-height: 38px;
  letter-spacing: 0px;
  text-align: center;
  margin-left: 42px;
}

button {
  width: 90px;
  height: 32px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  border: none;
  /* Small Button */
  color: rgb(255, 254, 254);
  font-family: Microsoft YaHei;
  font-size: 13px;
  font-weight: 400;
  line-height: 8px;
  letter-spacing: 0px;
  text-align: center;
  margin-left: 395px;
  margin-top: 10px;
  margin-bottom: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/teacherzhuli.vue